<template>
  <div class="layout">
    <!-- <div class="top"></div> -->
    <google-map ref="google-map" />
    <div class="title">
      <h2>address</h2>
      <p>101 Ruawai Road,MWellington, Auckland, NewZealand</p>
    </div>
    <div class="content">
      <h1>Accommodation in the surrounding area</h1>
      <div class="box">
        <ul v-for="(item, index) in list.slice(0, 2)" :key="index">
          <div class="boxIcon">
            <img :src="item.icon" alt="">
            {{ item.name }}
          </div>
          <li v-for="(item, index) in item.content" :key="index">
            <div>{{ item.name }}</div>
            <div>{{ item.distance }}</div>
          </li>
        </ul>
        <div class="innerbox">
          <ul class="colum" v-for="(item, index) in list.slice(2, 4)" :key="index">
            <div class="boxIcon">
              <img :src="item.icon" alt="">
              {{ item.name }}
            </div>
            <li v-for="(item, index) in item.content" :key="index"> <span>{{ item.name }}</span>
              <span>{{ item.distance }}</span> </li>
          </ul>
        </div>
      </div>
      <div class="box">
        <ul v-for="(item, index) in list.slice(4, 7)" :key="index">
          <div class="boxIcon">
            <img :src="item.icon" alt="">
            {{ item.name }}
          </div>
          <li v-for="(item, index) in item.content" :key="index"> <span>{{ item.name }}</span>
            <span>{{ item.distance }}</span> </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import GoogleMap from '../../components/googleMap/googleMap.vue';
export default {
  name: "Location",
  data() {
    return {
      list: [
        {
          icon: require("../../assets/img/locationIcon1.png"),
          name: "What's around here",
          content: [
            { name: "Stirling Women Sylvia Park", distance: "600meters" },
            { name: "Mac Cosmetics Sylvia Park", distance: "800meters" },
            { name: "Mecca Sylvia Park", distance: "850meters" },
            { name: "Piccolo Park", distance: "850meters" },
            { name: "2degrees Sylvia Park", distance: "900meters" },
            { name: "lrelax Sylvia Park", distance: "1kilometer" },
            { name: "Sylvia Park Citizen Advice Bureau", distance: "1.1kilometer" },
            { name: "sephora Sylvia Park", distance: "1.2kilometer" },
            { name: "Parker Hannifin", distance: "2kilometer" },
            { name: "Peterson Reserve Tamaki River", distance: "2.1kilometer" },
          ],
        },
        {
          icon: require("../../assets/img/locationIcon3.png"),
          name: "Popular attractions",
          content: [
            { name: "One Tree Hill", distance: "6kilometer" },
            { name: "Huoweike Historical Village", distance: "8kilometer" },
            { name: "Auckland War Memorial Museum", distance: "9kilometer" },
            { name: "Auckland Public Parks", distance: "10kilometer" },
            { name: "Kelly Tarlton Underwater World", distance: "11kilometer" },
            { name: "Otya Square", distance: "11kilometer" },
            { name: "Sky Tower", distance: "12kilometer" },
            { name: "Auckland Botanic Garden", distance: "12kilometer" },
            { name: "Auckland Harbour Bridge", distance: "15kilometer" },
            { name: "North Head Historic Reserve", distance: "18kilometer" },
          ],
        },
        {
          icon: require("../../assets/img/locationIcon5.png"),
          name: "What's around here",
          content: [
            { name: "St Heliers Bay Beach", distance: "9kilometer" },
            { name: "Kohimarama Beach", distance: "9kilometer" },
            { name: "Mission Bay Beach", distance: "10kilometer" },
          ],
        },
        {
          icon: require("../../assets/img/locationIcon6.png"),
          name: "public transportation",
          content: [
            { name: "train station · Sylvia Park", distance: "2.5kilometer" },
            { name: "train station · Penrose", distance: "8kilometer" },
            { name: "bus · 75 Robertson Rd", distance: "9kilometer" },
            { name: "bus · 21 McKinstry Ave", distance: "" },
          ],
        },
        {
          icon: require("../../assets/img/locationIcon2.png"),
          name: "Restaurants and cafes",
          content: [
            { name: "Caf é/Bar · THE COFFEE CLUB ", distance: "850meters" },
            { name: " restaurant · BURGER KING", distance: "750meters" },
            { name: "restaurant · The Little District", distance: "650meters" },
          ],
        },
        {
          icon: require("../../assets/img/locationIcon4.png"),
          name: "Natural scenery",
          content: [
            { name: "mountains and rivers · Crater Hill Volcano", distance: "" },
          ],
        },
        {
          icon: require("../../assets/img/locationIcon7.png"),
          name: "Lingjin Airport",
          content: [{ name: "Auckland Airport", distance: "15kilometer" }],
        },
      ],
    };
  },
  mounted() {
    const img = new Image();
    img.src = require("../../assets/img/locationMap.png");
    document.querySelector(".top").style.backgroundImage = "url(" + img.src + ")";
  },
  components: {
    GoogleMap
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/mainStyle.scss";
@import "location.scss";
</style>
